import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/top_up_statistics',
  component: Management,
  redirect: '/top_up_statistics/time_group_statistics',
  children: [
    // 时间分组统计
    {
      path: 'time_group_statistics',
      component: () => import('@/views/top_up_statistics/TimeGroupStatistics'),
      meta: {
        auth: Auth.showTopUpStatistics
      }
    },
    // 属性分组统计
    {
      path: 'prop_group_statistics',
      component: () => import('@/views/top_up_statistics/PropGroupStatistics'),
      meta: {
        auth: Auth.showTopUpStatistics
      }
    }
  ]
}
